import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomNavbar from "../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const AddFileType = () => {
  const [fileTypes, setFileTypes] = useState([]);
  const [fileTypeName, setFileTypeName] = useState("");
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchFileTypes();
  }, []);

  const fetchFileTypes = async () => {
    try {
      const response = await axios.get(
        getApiUrl("/PartnerFiles/filetypes/"),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setFileTypes(response.data);
    } catch (error) {
      console.error("Error fetching file types:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fileTypeName.trim()) {
      setMessage("File type name is required");
      return;
    }

    try {
      if (isEdit) {
        await axios.put(
          getApiUrl(`/PartnerFiles/filetypes/${selectedFileType.id}/`),
          { name: fileTypeName },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        setMessage("File Type updated successfully!");
      } else {
        await axios.post(
          getApiUrl("/PartnerFiles/filetypes/"),
          { name: fileTypeName },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        setMessage("File Type added successfully!");
      }
      setFileTypeName("");
      setIsEdit(false);
      setSelectedFileType(null);
      fetchFileTypes();
    } catch (error) {
      console.error("Error saving file type:", error);
    }
  };

  const handleEdit = (fileType) => {
    setFileTypeName(fileType.name);
    setSelectedFileType(fileType);
    setIsEdit(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        getApiUrl(`/PartnerFiles/filetypes/${id}/`),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setMessage("File Type deleted successfully!");
      fetchFileTypes();
    } catch (error) {
      console.error("Error deleting file type:", error);
    }
  };

  return (
    <div className="flex">
      <CustomNavbar />
      <div className="max-w-2xl mx-auto mt-3 p-3 bg-white shadow-md rounded-lg">
        <h2 className="text-2xl font-bold text-blue-500 mb-4">
          {isEdit ? "Edit File Type" : "Add File Type"}
        </h2>
        {message && (
          <div className="mb-4 p-2 text-green-800 bg-green-100 border border-green-300 rounded">
            {message}
          </div>
        )}
        <form onSubmit={handleSubmit} className="mb-3">
          <input
            type="text"
            placeholder="Enter file type name"
            value={fileTypeName}
            onChange={(e) => {
              setFileTypeName(e.target.value);
              setMessage("");
            }}
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring focus:ring-blue-200"
            required
          />
          <button
            type="submit"
            className="mt-4 w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-200"
          >
            {isEdit ? "Update" : "Add"}
          </button>
        </form>

        <h3 className="text-xl font-bold text-blue-500 mb-4">File Types</h3>
        {fileTypes.length > 0 ? (
          <table className="min-w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-blue-500">
                <th className="border border-gray-300 px-4 py-2">#</th>
                <th className="border border-gray-300 px-4 py-2">File Type</th>
                <th className="border border-gray-300 px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {fileTypes.map((fileType, index) => (
                <tr key={fileType.id} className="border border-gray-300">
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    {index + 1}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    {fileType.name}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    <button
                      onClick={() => handleEdit(fileType)}
                      className="px-2 py-1 text-yellow-500 hover:text-yellow-700 mx-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-pen-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001" />
                      </svg>
                    </button>
                    <button
                      onClick={() => handleDelete(fileType.id)}
                      className="px-2 py-1 text-red-500 hover:text-red-700 mx-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-gray-600 text-center mt-4">
            No file types available.
          </p>
        )}
      </div>
    </div>
  );
};

export default AddFileType;
